/*
 * Public API Surface of smart-tooltip-angular
 */

export * from './lib/smart-tooltip-angular.service';
export * from './lib/smart-tooltip-angular.directive';
export * from './lib/smart-tooltip-angular.module';
